<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" [ngStyle]="{ height: '100%' }" style="min-height: 300px" *ngIf="entities">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [dataSource]="entities"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onRowPrepared)="rowPrepare($event)"
        >
            <dxi-column dataField="userName" caption="Username"></dxi-column>
            <dxi-column dataField="firstName" caption="First Name"></dxi-column>
            <dxi-column dataField="lastName" caption="Last Name"></dxi-column>
            <dxi-column dataField="email" caption="Email"></dxi-column>
            <dxi-column dataField="displayRoles" caption="Roles"></dxi-column>
            <dxi-column dataField="deleted" caption="Deleted"></dxi-column>

            <dxo-export [enabled]="true" [allowExportSelectedData]="false"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button type="button" class="btn btn-success" (click)="open(dataGrid.instance.getSelectedRowsData()[0])">Open</button>
                <button type="button" class="btn btn-secondary ml-2" (click)="open()">New</button>
                <button type="button" class="btn btn-sm btn-danger ml-2" (click)="delete()">Delete</button>
            </div>
        </dx-data-grid>
    </div>
    <div>
        <dx-toast message="Changes Saved!" type="success" [displayTime]="500" [maxWidth]="300" [position]="'bottom right'" [(visible)]="isToastVisible"> </dx-toast>
    </div>
</div>
